// @flow
import * as React from 'react';
import LAFooterContainer from './LAFooter/LAFooterContainer';
import WhiteLabelFooterContainer from './WhiteLabelFooter/WhiteLabelFooterContainer';

type Props = {|
    whiteLabel: boolean,
|};

const Footer = ({ whiteLabel }: Props) => {
    return whiteLabel ? <WhiteLabelFooterContainer /> : <LAFooterContainer />;
};

export default React.memo<Props>(Footer);
